<template>
  <div class="inline-search__placeholder" aria-hidden="true">
    Search for
    <transition-group name="placeholder-topics">
      <span :key="visiblePlaceholderTopic">{{ visiblePlaceholderTopic }}</span>
    </transition-group>
  </div>
</template>
<style>
  .placeholder-topics-enter-active,
  .placeholder-topics-leave-active {
    transition-property: opacity, transform;
    transition-duration: 600ms, 600ms;
  }
  .placeholder-topics-enter-from {
    opacity: 0;
    transform: translateX(-10px);
  }
  .placeholder-topics-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>
<script>
  export default {
    data: () => ({
      visiblePlaceHolderTopicIndex: 0
    }),
    props: {
      placeholderTopics: {
        type: Object,
        required: true
      },
    },
    mounted() {
      setInterval(() => {
        if (this.visiblePlaceHolderTopicIndex < this.placeholderTopics.length - 1) {
          this.visiblePlaceHolderTopicIndex++
        } else {
          this.visiblePlaceHolderTopicIndex = 0
        }
      }, 3000)
    },
    computed: {
      visiblePlaceholderTopic() {
        return this.placeholderTopics[this.visiblePlaceHolderTopicIndex];
      }
    }
  }
</script>
